import { defineComponent } from 'vue'

/**
 * Types used in `CABackdrop` component
 * @component CABackdrop
 *
 * @typedef {('dark' | 'light')} BackdropLight - The lightness of the backdrop.
 *
 * @prop {boolean} light - Whether the backdrop is light or dark.
 * @prop {boolean} open - Whether the backdrop is open or closed.
 */
export default defineComponent({
	name: 'CABackdrop',

	props: {
		/**
		 * Whether the backdrop is light or dark.
		 * @default false
		 * @type {boolean}
		 */
		light: { default: false, type: Boolean },
		/**
		 * Whether the backdrop is open or closed.
		 * @default false
		 * @type {boolean}
		 */
		open: { default: false, type: Boolean },
	},

	emits: ['click'],

	render() {
		const classes = [
			'ca-layout-backdrop',
			this.open ? 'open' : '',
			this.light ? 'light' : 'dark',
		]

		return (
			<div
				class={classes}
				data-test="ca-layout-backdrop"
				onClick={() => this.$emit('click')}
			/>
		)
	},
})
